import type { ReactNode } from 'react';

import useClassy from '@core/hooks/useClassy';

import classes from './style.module.scss';

interface Props {
  errorCode?: number | string;
  errorMessage: ReactNode;
  padding?: 'lg' | 'md' | 'sm';
}

const APIErrorBoundary = ({ errorCode, errorMessage, padding, ...props }: Props) => {
  const bem = useClassy(classes, 'APIErrorBoundary');

  return (
    <section className={bem('&', padding && `_${padding}`)} {...props}>
      <span aria-hidden className={bem('-icon')} role="img">
        ⚠️
      </span>
      <p className={bem('-message')}>{errorMessage}</p>
      {!!errorCode && <code className={bem('-code')}>{errorCode}</code>}
    </section>
  );
};

export default APIErrorBoundary;
